import { BillContractualCycle } from "@/features/billingBills/types/bills.type";
import { isValidDate } from "./dateValidator";
import { weekDayLabels } from "../constants/weekDays.constants";
import { getDateDiffInDays } from "./date";

export const dateTransformer = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

export const dateTimeTransformer = (date: Date) => {
  return `${date.toLocaleDateString()} - ${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
};

export const dateToISOStingTransformer = (date: Date | string | undefined) => {
  if (!date) {
    return "";
  }

  if (date instanceof Date) {
    date = date.toISOString();
  }

  return date ? `${date?.split("T")[0]}` : "";
};

type FormatDatePeriodFriendlyNameProps = {
  closedAt: string;
  openedAt: string;
  contractualCycle?: BillContractualCycle | null;
};

export const formatDatePeriodFriendlyName = (data?: FormatDatePeriodFriendlyNameProps): string => {
  if (!data?.openedAt || !data?.closedAt || !data?.contractualCycle) return '--';

  const openedAtDate = new Date(data.openedAt);
  const closedAtDate = new Date(data.closedAt);
  const openedAtDay = openedAtDate.getDate();
  const closedAtDay = closedAtDate.getDate();
  const cycle = data.contractualCycle;

  if (!isValidDate(openedAtDate) || !isValidDate(closedAtDate)) return '--';

  const strategies: Record<BillContractualCycle, () => string> = {
    weekly: () => {
      const weekDay = weekDayLabels[openedAtDate.getUTCDay()]
      return weekDay ? `Semanal - ${weekDay}` : 'Semanal'
    },
    monthly: () => {
      const monthDay = String(openedAtDay).padStart(2, '0')
      return `Mensal - Dia ${monthDay}`
    },
    fixed: () => {
      const interval = getDateDiffInDays(openedAtDate, closedAtDate)
      return interval ? `Intervalo Fixo - ${interval} dias` : 'Intervalo Fixo'
    },
    fortnightly: () => {
      if(openedAtDay < 15 && closedAtDay <= 15) return '1ª Quinzena'

      if(openedAtDay >= 15 && closedAtDay > 15) return '2ª Quinzena'

      return 'Quinzenal'
    }
  }

  const formatPeriod = strategies[cycle]

  return formatPeriod ? formatPeriod() : '--'
};